import LogoWhite from '@assets/images/common/brand/logo-white.svg';
import DownWhite from '@assets/images/common/icon/arrow/down-white.svg';
import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { tenantMenuApiClient } from '@src/api/tenant/menus/tenantMenuApiClient';
import { Menu } from '@src/api/types/menu';
import { TENANT_URL } from '@src/routes/tenant';
import logger from '@src/utils/logger.ts';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const [menus, setMenus] = useState<Menu[]>([]);
  const location = useLocation();

  useEffect(() => {
    const fetchMenu = async () => {
      const cachedMenus = localStorage.getItem('tenantMenus');
      if (cachedMenus) {
        setMenus(JSON.parse(cachedMenus));
      }

      const res = await tenantMenuApiClient.index();
      handleApiResponse(res, (data) => {
        setMenus(
          data.map((menu) => ({
            ...menu,
            items: menu.items.map((item) => ({
              ...item,
              isCurrent: location.pathname === item.link,
              items: item.items.map((subItem) => ({
                ...subItem,
                isCurrent: location.pathname === subItem.link,
              })),
            })),
          })),
        );
        localStorage.setItem('tenantMenus', JSON.stringify(data));
      });
      if (res.result !== 'success') {
        logger.error(res.message);
        return;
      }
    };
    fetchMenu();
  }, []);

  return (
    <aside className='h-full w-[240px] border-collapse bg-primary-800'>
      <Link
        to={TENANT_URL.HOME}
        className='block p-[10px]'
      >
        <img
          src={LogoWhite}
          alt=''
          className='block h-auto max-h-[40px] w-[220px] object-contain'
        />
      </Link>
      <ul className='bg-primary-800 px-4 pb-10'>
        {menus.map((section, sectionIndex) => (
          <li key={sectionIndex}>
            <p
              className={`${sectionIndex === 0 ? 'py-[11px]' : 'pb-[11px] pt-[24px]'} text-sm text-white`}
            >
              {section.title}
            </p>
            <div>
              {section.items.map((item, itemIndex) => {
                const isOpen =
                  item.items &&
                  item.items.some((dropdownItem) =>
                    location.pathname.startsWith(dropdownItem.link),
                  );
                if (item.items && item.items.length > 0) {
                  return (
                    <details
                      key={itemIndex}
                      className='group'
                      open={isOpen}
                    >
                      <summary className='flex cursor-pointer items-center gap-4 px-4 py-[11px] text-sm text-white'>
                        <div className='size-[10px]'>
                          <img
                            className='-rotate-90 transition-transform group-open:rotate-0'
                            src={DownWhite}
                            alt=''
                            width='10'
                            height='10'
                          />
                        </div>
                        <div className='select-none text-sm'>{item.title}</div>
                      </summary>
                      <div className='flex flex-col pl-4 text-white'>
                        {item.items.map((dropdownItem, dropdownIndex) => (
                          <Link
                            key={dropdownIndex}
                            to={dropdownItem.link}
                            className={`px-5 py-[11px] text-sm text-white transition-colors ${dropdownItem.isCurrent ? 'bg-primary-700' : ''} hover:bg-primary-700`}
                          >
                            ・{dropdownItem.title}
                          </Link>
                        ))}
                      </div>
                    </details>
                  );
                } else {
                  return (
                    <div
                      key={itemIndex}
                      className='flex flex-col gap-4 text-white'
                    >
                      <Link
                        to={item.link}
                        className={`px-4 py-[11px] text-sm text-white transition-colors ${item.isCurrent ? 'bg-primary-700' : ''} hover:bg-primary-700`}
                      >
                        ・{item.title}
                      </Link>
                    </div>
                  );
                }
              })}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
